module.exports = __webpack_public_path__ + "static/media/logo_bandeira.a4762b4a.svg";